import { makeStyles } from '@material-ui/core/styles';
import GridAreaContainer from '@sprinx/react-mui-components/GridAreaContainer';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
// import NumberFieldPreview from '@sprinx/react-mui-fields/NumberFieldPreview';
import TextFieldPreview from '@sprinx/react-mui-fields/TextFieldPreview';
import clsx from 'clsx';
import React from 'react';
import NumberFieldPreview from '@sprinx/react-mui-fields/NumberFieldPreview';
import { useRecoilValue } from 'recoil';
import { CatalogueProduct } from '../../../api/products/catalogue';
import { isAuthenticatedState } from '../../../api/appState';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export interface CataloguePageListContentItemRowInlineParametersProps
  extends StandardDivProps<CataloguePageListContentItemRowInlineParametersClassKey> {
  product: CatalogueProduct;
}

export type CataloguePageListContentItemRowInlineParametersClassKey = 'root' | 'field';

const themeSettings = { name: 'CataloguePageListContentItemRowInlineParameters' };
const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      '@media(min-width: 1280px) and (max-width: 1440px)': {
        maxWidth: '325px',
      },
      '@media(min-width: 960px) and (max-width: 1155px)': {
        maxWidth: '284px',
      },
    },
    field: {
      [theme.breakpoints.down('sm')]: {
        width: '30%',
      },
    },
    fieldCode: {
      [theme.breakpoints.down('sm')]: {
        width: '40%',
      },
    },
    // expirationDateField: {
    //   [theme.breakpoints.down('sm')]: {
    //     width: '50%',
    //   },
    //   width: 'max-content',
    // },
  }),
  themeSettings,
);

const CataloguePageListContentItemRowInlineParameters = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemRowInlineParametersProps
>(({ className, classes: pClasses, product, ...rest }, ref) => {
  const classes = useStyles({ classes: pClasses });
  // const expirationDate = product && product.extra ? (product.extra as any).expirationDate : undefined;
  const t = useTranslateWithFallback();
  const isAuthenticated = useRecoilValue(isAuthenticatedState);

  return (
    <GridAreaContainer ref={ref} className={clsx(classes.root, className)} renderToGridArea='parameters' {...rest}>
      <TextFieldPreview label={t('common/code')} value={product.sku || ''} size='small' className={classes.fieldCode} />
      {isAuthenticated && (
        <NumberFieldPreview
          label={t('productPage/minOrderableQuantity')}
          value={product.quantityStep}
          size='small'
          decimalPrecision={0}
          className={classes.field}
        />
      )}
      {/* {expirationDate && (
        <TextFieldPreview
          label={t('common/expiration')}
          value={dateFormatter(expirationDate)}
          size='small'
          className={classes.expirationDateField}
        />
      )} */}
    </GridAreaContainer>
  );
});

CataloguePageListContentItemRowInlineParameters.displayName = 'CataloguePageListContentItemRowInlineParameters';

export default withThemeProps(themeSettings)(CataloguePageListContentItemRowInlineParameters);
